import { Component, OnInit } from '@angular/core';
import { CucurachaAdminService } from '../service/cucuracha.service';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ViewChild } from '@angular/core';
import { ToastrManager } from 'ng6-toastr-notifications';
import { TableUtil } from '../tableUtil';
import { ExcelService } from '../service/tableUtility.service';
import { userAccount } from '../models/userAccountManagement';

@Component({
  selector: 'app-useraccountmanagement',
  templateUrl: './useraccountmanagement.component.html',
  styleUrls: ['./useraccountmanagement.component.css']
})
export class UseraccountmanagementComponent implements OnInit {
userAccountAddObj:userAccount
  showFilter:boolean=false
  dataSource:any;
  tableData: [] = [];
  userDetails:any;
  userSessionData:any
  read:any;
  write:any;
  delete:any;
  export:any
  searchValue:any;
  filterValueSelected:any;
  showCustomisedSearch:boolean=false
  displayedColumns = [ 'CompanyName', 'CompanySize','UserMobileNumber','EmailId','Address' ,'AccountStatus','status','dateOfCreation','Action']
  @ViewChild(MatSort,{static:true}) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;  
  constructor(private cs:CucurachaAdminService,private toastr: ToastrManager, private excelService: ExcelService) { 
    this.userAccountAddObj=new userAccount()
  }
  filter() {
    this.getAllUserAccounts()
    if (this.showFilter == false) {
      this.showFilter = true
      this.showCustomisedSearch = false
      this.searchValue=""
      this.filterValueSelected=""
    }
    else {
      this.showFilter = false
      this.showCustomisedSearch = false
      this.searchValue=""
      this.filterValueSelected=""
    }
  }
  applyCustomizedFilter() {
    this.showCustomisedSearch = true
    this.searchValue=""
    this.getAllUserAccounts();

  }
  applyCustomizedFilterSearch(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue;

    if (filterValue != "") {
      this.cs.customizedFilterForUserAccounts(this.filterValueSelected, filterValue).subscribe((data) => {
        console.log(data)
        this.dataSource = new MatTableDataSource(data)

      })
    }
    else {
      this.getAllUserAccounts()
    }
  }
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }
  getAllUserAccounts(){
    this.cs.getAllUserAccounts().subscribe((data) => {
      console.log(data)
      this.dataSource = new MatTableDataSource(data)
      this.dataSource.sort = this.sort
      this.dataSource.paginator = this.paginator
    })
  }
  deleteuserAccount(id:any){
    this.cs.deleteuserAccount(id).subscribe((data) => {
      this.getAllUserAccounts()
      this.toastr.warningToastr("Data  Deleted");

    })
  }
  exportTable(){
    // TableUtil.exportToExcel("Example table",'userAccountmanagement.xlsx');
    this.tableData = (this.dataSource.filteredData)
      console.log(this.tableData)
      this.excelService.exportAsExcelFile(this.tableData, 'UserAccounts');
      this.cs.exportLogAdd(this.userDetails.emailId, 'UserAccounts').subscribe((data) => {
      })
  }
  onChange(status, id) {
    console.log(status.checked)
    this.cs.getByUserAccountId(id).subscribe((data) => {
      this.userAccountAddObj._id = data[0]._id;
      this.userAccountAddObj.status = status.checked;

      this.cs.updateUserAccountStatus(this.userAccountAddObj).subscribe((data) => {
        if(data.result ){
          this.getAllUserAccounts()
          this.toastr.infoToastr(data.message);
          
          }
         else if(data.err){
          this.toastr.warningToastr(data.message);
          this.getAllUserAccounts()
    
         }
          else{
            this.toastr.errorToastr(data.message);
            this.getAllUserAccounts()

    
          }
      })
    })
  }
  ngOnInit(): void {
    this.getAllUserAccounts();
    this.userSessionData = (JSON.parse(localStorage.getItem('user')))

    this.cs.getUserDataByEmailId(this.userSessionData).subscribe((data) => {
      this.userDetails=data[0]
      this.read=(this.userDetails.roledetails[0].components[0].component_name[0][0].userAccount_management.permissions[0].read);
      this.write=(this.userDetails.roledetails[0].components[0].component_name[0][0].userAccount_management.permissions[0].write)
      this.delete=(this.userDetails.roledetails[0].components[0].component_name[0][0].userAccount_management.permissions[0].delete)
      this.export=(this.userDetails.roledetails[0].components[0].component_name[0][0].userAccount_management.permissions[0].export)

    })
  }

}
